import DiscountModal from './DiscountModal';

export default DiscountModal;
